import { render, staticRenderFns } from "./JustificativaDispensa.vue?vue&type=template&id=e6197eb4"
import script from "./JustificativaDispensa.vue?vue&type=script&lang=js"
export * from "./JustificativaDispensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports